import { useCapacitorAuth } from '~/composables/useCapacitorAuth'

export default defineNuxtPlugin(async () => {
  const isNative = useIsNative()

  if (!isNative) return

  const auth = useAuth()
  const capacitorAuth = useCapacitorAuth()

  if (!auth.loggedIn) {
    const tokens = await capacitorAuth.getTokens()
    if (tokens?.accessToken && tokens?.refreshToken) {
      try {
        await auth.setUserToken(tokens.accessToken, tokens.refreshToken)
      } catch (e) {
        console.error('Failed to restore auth tokens:', e)
        await capacitorAuth.clearTokens()
      }
    }
  }

  // Every rotation writes new values into the module's state, so mirror both keys rather
  // than relying on the login response alone.
  const { name, options } = auth.strategy
  const tokenKey = `${options.token?.prefix ?? '_token.'}${name}`
  const refreshTokenKey = `${options.refreshToken?.prefix ?? '_refresh_token.'}${name}`

  // watchState calls back synchronously and cannot await, so syncTokens handles its own
  // storage failures and never rejects.
  const mirror = () => {
    capacitorAuth.syncTokens()
  }

  auth.$storage.watchState(tokenKey, mirror)
  auth.$storage.watchState(refreshTokenKey, mirror)
})
